<i18n>
{
  "cl": {
    "page-not-found" : "Página no encontrada",
    "expired-credentials-ini":"Tus credenciales se vencieron. Te acabamos de enviar un correo a",
    "expired-credentials-fin":"para que puedas ingresar nuevamente",
    "simulator-button":"Simulador",
    "help-message-title": "Centro de ayuda"
  },
  "pe": {
    "page-not-found" : "Página no encontrada",
    "expired-credentials-ini":"Tus credenciales se vencieron. Te acabamos de enviar un correo a",
    "expired-credentials-fin":"para que puedas ingresar nuevamente",
    "simulator-button":"Simulador",
    "help-message-title": "Centro de ayuda"
  },
  "br": {
    "page-not-found" : "Página não encontrada",
    "expired-credentials-ini":"Suas credenciais expiraram. Acabamos de lhe enviar um e-mail para",
    "expired-credentials-fin":"para que você possa fazer login novamente",
    "simulator-button":"Simulador",
    "help-message-title": "Centro de ajuda"
  }
}
</i18n>
<template>
  <div>
    <Header />
    <div class="document-content transition-slow">
      <div class="card-item document-view">
        <div v-if="email == null" class="has-text-centered">
          <img src="@/ui/assets/img/unlink.gif" width="80">
          <div class="mt-3 box is-shadowless">
            <h3>{{ $t('page-not-found') }}</h3>
          </div>
        </div>
        <div v-if="email != null" class="has-text-centered">
          <img src="@/ui/assets/img/time.gif" width="80">
          <div class="mt-3 box is-shadowless">
            <h3 class="is-size-6-mobile">{{ $t('expired-credentials-ini') }} <strong>{{ obscureEmail( email) }}</strong> {{ $t('expired-credentials-fin') }}</h3>
          </div>
        </div>
        <div class="my-5 has-text-centered">
          <b-button rounded type="is-success" class="px-6 mx-2" @click="redirectSimulator()">{{ $t('simulator-button') }}</b-button>
          <b-button rounded type="is-primary" outlined class="px-6 mx-2" @click="redirectHelpCenter()">{{ $t('help-message-title') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/ui/components/Header.vue';
import { sendEmailProspectRetoken } from '@/application/services/api-clients/prospects-leads';

export default {
  name: 'ReTokenForm',
  components: { Header },
  data() {
    return {
      token: null,
      isLoading: false,
      email: null,
      emailReTokenSent: false
    };
  },
  created() {
    if (this.$route.params.data) {
      this.token = this.$route.params.data.token || null;
      this.email = this.decodeToken(this.token);
      this.emailReTokenSent = sendEmailProspectRetoken(this.email);
    }
  },
  methods: {
    decodeToken: token => {
      if (token) {
        const [, payload] = token.split('.');
        try {
          const { email } = JSON.parse(Buffer.from(payload, 'base64').toString('binary'));
          return email;
        } catch {
          return null;
        }
      }
      return null;
    },
    obscureEmail(email) {
      if (!email) return email;
      const parts = email.split('@');
      const name = parts[0];
      let result = name.charAt(0) + name.charAt(1);
      for (let i = 2; i < name.length; i += 1) {
        result += '*';
      }
      result += name.charAt(name.length - 1);
      result += '@';
      const domain = parts[1];
      result += domain;

      return result;
    },
    redirectHelpCenter() {
      let link = 'https://www.creditu.com/br/ajuda/';
      let target = '_blank';
      if (this.$i18n.locale === 'cl') {
        link = 'https://ayuda.creditu.com/';
        target = '_blank';
      } else if (this.$i18n.locale === 'pe') {
        link = 'https://www.creditu.com/wp/pe/ayuda/index.html';
        target = '_blank';
      }
      window.open(link, target);
    },
    redirectSimulator() {
      let link = 'https://simulador.creditu.com/br/simulation';
      let target = '_blank';
      if (this.$i18n.locale === 'cl') {
        link = 'https://simulador.creditu.com/cl/simulation';
        target = '_blank';
      } else if (this.$i18n.locale === 'pe') {
        link = 'https://simulador.creditu.com/pe/simulation';
        target = '_blank';
      }
      window.open(link, target);
    }

  }
};
</script>
<style lang="css" scoped>
  .document-content {
    width: 100%;
    min-height: calc(100vh - 50px);
    background-color: #4d4d4d0a;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: 40% auto;
    margin-top: 50px;
  }
  .document-view {
    width: 80%;
    padding: 60px 40px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  .box {
    background-color: #f2fbfb;
    max-width: 500px;
    margin: auto;
  }

@media (max-width: 640px) {
  .button {
    width: 100%;
    margin-bottom: 10px;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>
